import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';

import { SENTRY } from '@modules/_misc';
import withRouter from '@wrappers/withRouter';
import OnError from '@views/NotAvailable/OnError';

const { VITE_ENV } = import.meta.env;

const MyErrorBoundary = props => {
	const { children } = props,
		prev_page = useSelector(state => state.global.prev_page),
		email = useSelector(state => state.user.email),
		app_id = useSelector(state => state.user.app_id),
		campus_admin = useSelector(state => state.user.campus_admin),
		support_student_id = useSelector(state => state.user.support_student_id);

	return (
		<ErrorBoundary
			FallbackComponent={({ error, resetErrorBoundary }) => (
				<OnError error={error} resetErrorBoundary={resetErrorBoundary} />
			)}
			onError={(error, info) => {
				// TODO:  can I log the stack (info)?

				if (SENTRY.use) {
					Sentry.captureException(error, {
						user: { username: email || '<anonymous>' },
						tags: {
							environment: VITE_ENV || '<undetermined>',
							set_app_id: app_id || '<none>',
							previous_page: prev_page || '<none>',
							campus_admin: campus_admin,
							support_student_id: support_student_id || '<none>'
						}
					});
				} else {
					console.log(error);
				}
			}}>
			{children}
		</ErrorBoundary>
	);
};

export default withRouter(MyErrorBoundary);
